export default __webpack_public_path__ + "static/media/50-51.bb1db000.png";